import { render, staticRenderFns } from "./eventoviewfactura.vue?vue&type=template&id=8cffb8c6"
import script from "./eventoviewfactura.vue?vue&type=script&lang=js"
export * from "./eventoviewfactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports